import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "./Routes";
import ScrollToTop from "./components/ScrollToTop";
import themeManager from "./utils/themeManager";
import Footer from "./components/ui/Footer";

function App() {
  useEffect(() => {
    // Theme manager se inicijalizuje automatski
    // Dodajemo dark temu ako sistem preferira
    console.log("PC Centar - Theme Manager initialized:", themeManager.getCurrentTheme());
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Routes />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;

